<template>
  <div class="container page-content">

    <div class="row page-content__heading">
      <div class="col-md-7">
        <h1>{{ $t('terms_conditions.heading') }}</h1>
      </div>
      <div class="col-md-5 heading__info" v-html="$t('terms_conditions.date_info')"></div>
    </div>

    <div class="page-content__terms">
      
      <div class="row">
        <div class="col" v-html="$t('terms_conditions.step1')"></div>
      </div>

      <div class="row">
        <div class="col">
          <img class="img-fluid" src="@/assets/images/terms-icons.png" alt="amica">
        </div>
      </div>

      <div class="row">
        <div class="col" v-html="$t('terms_conditions.step2')"></div>
      </div>

      <div class="row">
        <div class="col" v-html="$t('terms_conditions.step3')"></div>
      </div>

      <div class="row">
        <div class="col" v-html="$t('terms_conditions.step4')"></div>
      </div>

    </div>

  </div>
</template>

<script>
  import scrollToElement from 'scroll-to-element'

  export default {
    name: 'Terms',
    mounted () {
      scrollToElement('.page-content', {
        offset: 0,
        ease: 'out-cube',
        duration: 800
      })
    }
  }
</script>

<style lang="scss" scoped>
  .page-content {
    padding-top: 50px;
    padding-bottom: 50px;

    .page-content__heading {
      margin-bottom: 40px;
      
      h1 {
        font-size: 34px;
        font-weight: 300;
      }

      .heading__info {
        font-size: 13px;
        padding-top: 10px;
      }
    }

    .page-content__terms {
      font-size: 18px;
      font-weight: 300;
      
      & > .row {
        margin-bottom: 30px;

        & /deep/ strong {
          color: #e41429;
          font-weight: 900;
        }

      }
    }
  }
</style>
